import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

import { NotificationSettingsCategories } from './notifications.types'

export const notificationsApi = {
  readAllNotification: (
    type: components['schemas']['AlertServiceType'],
    locale: string
  ) =>
    getApiClient(locale)
      .put('v1/alerts', null, {
        params: {
          type
        }
      })
      .then(({ data }) => data),

  readNotification: (
    notificationId: number,
    type: components['schemas']['AlertServiceType'],
    locale: string
  ) =>
    getApiClient(locale)
      .put(`v1/alerts/${notificationId}`, { type })
      .then(({ data }) => data),

  getNotifications: (
    type: components['schemas']['AlertServiceType'],
    locale: string
  ) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['AlertResource'][] }>('v1/alerts', {
        params: { type }
      })
      .then(({ data }) => data.data),

  getCountNewNotification: (locale: string) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['AlertsCountResource']
      }>('v1/alerts/count')
      .then(({ data }) => data?.data),

  subscribeTaskNotifications: (taskId: number, locale: string) =>
    getApiClient(locale)
      .post('v1/notifications/subscribe', { taskId })
      .then(({ data }) => data),

  subscribeTeamTaskNotifications: (taskId: number, locale: string) =>
    getApiClient(locale)
      .post('v1/notifications/subscribe-team', { taskId })
      .then(({ data }) => data),

  addSubscriberLanding: (
    requestBody: components['schemas']['AddSubscriberRequest'],
    locale: string
  ) => getApiClient(locale).post('v1/notifications/subscribers', requestBody),

  getNotificationsSettings: (
    type: components['schemas']['AlertServiceType'],
    locale: string
  ) =>
    getApiClient(locale)
      .get<{
        data: NotificationSettingsCategories
      }>(`v1/alerts/settings/${type}`)
      .then(({ data }) => data.data),

  saveNotificationsSettings: (
    type: components['schemas']['AlertServiceType'],
    requestBody: components['schemas']['SaveSettingsRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .post(`v1/alerts/settings/${type}`, requestBody)
      .then(({ data }) => data),

  setNotificationSettings: (
    type: components['schemas']['AlertServiceType'],
    requestBody: components['schemas']['SaveAllSettingsRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .post(`v1/alerts/settings/${type}/all`, requestBody)
      .then(({ data }) => data)
}
